<template>
    <div>
        <PagesIndexSlider />
        <UContainer>
            <div class="-m-t-[var(--offset)] content-container">
                <PagesIndexCategory />
                <div class="my-16">
                    <div class="text-center flex justify-center">
                        <UiComponentTypography
                            class-name="font-normal border-b-2 border-amazon-500 py-4 px-6 md:px-16 bg-transparent shadow-xl relative remove-extra-shadow dark:text-sandstone-200"
                            tag="h1"
                            variant="h2"
                        >
                            چرا باید انتخابت
                            <UiBrandText class="mx-1" />
                            باشه
                        </UiComponentTypography>
                    </div>
                    <div class="flex max-md:flex-col justify-center max-md:mt-8">
                        <div class="md:w-1/2 flex-1 grid grid-rows-2 max-md:gap-8">
                            <div class="flex items-center gap-6">
                                <div class="w-1/4">
                                    <NuxtImg
                                        alt=""
                                        loading="lazy"
                                        format="webp"
                                        src="/Images/pages/index/why-northland-icon-1.png"
                                        class="w-full"
                                    />
                                </div>
                                <UiComponentTypography class="w-3/4 text-justify">
                                    در نرس‌لند، اولویت اصلی ما ارائه قهوه‌ای با کیفیت بی‌نظیر است. از انتخاب بهترین
                                    دانه‌ها تا فرآیندهای پیشرفته، همه چیز با دقت و عشق به قهوه انجام می‌شود.
                                </UiComponentTypography>
                            </div>
                            <div class="flex max-md:flex-row-reverse items-center gap-6">
                                <div class="w-1/4">
                                    <NuxtImg
                                        alt=""
                                        loading="lazy"
                                        format="webp"
                                        src="/Images/pages/index/why-northland-icon-2.png"
                                        class="w-full"
                                    />
                                </div>
                                <UiComponentTypography class="w-3/4 text-justify">
                                    ما در نرس‌لند از به‌روزترین و مدرن‌ترین دستگاه‌های دنیا برای فرآوری و بسته‌بندی قهوه
                                    استفاده می‌کنیم، تا هر فنجان قهوه‌ای که می‌نوشید، بهترین طعم و عطر را داشته باشد.
                                </UiComponentTypography>
                            </div>
                        </div>
                        <div class="w-1/3 max-md:hidden">
                            <NuxtImg
                                alt=""
                                height="60vh"
                                format="webp"
                                loading="lazy"
                                size="250px sm:300px lg:500px"
                                src="/Images/pages/index/why-northland-coffee.png"
                                class="mix-blend-darken dark:mix-blend-exclusion mx-auto max-h-[60vh]"
                            />
                        </div>
                        <div class="md:w-1/2 flex-1 grid grid-rows-2 max-md:gap-8 max-md:mt-8">
                            <div class="flex max-md:flex-row-reverse items-center gap-6">
                                <UiComponentTypography class="w-3/4 text-justify">
                                    در نرس‌لند، تمام مراحل تولید و نظارت با سیستم‌های پیشرفته و دقیق انجام می‌شود تا هر
                                    محصولی که به دست شما می‌رسد، مطابق با بالاترین استانداردها باشد.
                                </UiComponentTypography>
                                <div class="w-1/4">
                                    <NuxtImg
                                        alt=""
                                        loading="lazy"
                                        format="webp"
                                        src="/Images/pages/index/why-northland-icon-3.png"
                                        class="w-full"
                                    />
                                </div>
                            </div>
                            <div class="flex items-center gap-6">
                                <UiComponentTypography class="w-3/4 text-justify">
                                    ما به تعادل بین کیفیت بالا و قیمت مناسب اهمیت می‌دهیم. رضایت شما از خرید و تجربه
                                    نوشیدن قهوه، هدف اصلی ما در نرس‌لند است.
                                </UiComponentTypography>
                                <div class="w-1/4">
                                    <NuxtImg
                                        alt=""
                                        loading="lazy"
                                        format="webp"
                                        src="/Images/pages/index/why-northland-icon-4.png"
                                        class="w-full"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </UContainer>
        <div class="my-6 bg-sandstone-300 dark:bg-sandstone-800 rounded-t-[5rem] relative">
            <div class="absolute inset-0 bg-coffee-pattern invert mix-blend-overlay bg-[length:100%] opacity-20"></div>
            <div class="relative z-10 min-h-64 lg:min-h-64 p-4 lg:p-8">
                <div class="absolute right-0 max-lg:-bottom-[40%] lg:-top-16 h-full max-lg:w-full">
                    <NuxtImg
                        alt=""
                        class="h-full lg:h-[175%] w-full object-contain max-lg:object-bottom"
                        src="https://static.northland-co.com/images/pages/index/top-seller-products-image.png"
                        width="600"
                        sizes="300px sm:450px lg:600px"
                        format="webp"
                        loading="lazy"
                    />
                </div>
                <div class="lg:pl-64 flex items-center max h-full">
                    <div class="grow"></div>
                    <div class="w-full lg:w-1/3 flex flex-col lg:justify-center items-center h-full">
                        <UiComponentTypography variant="h3" class-name="text-amazon-700 leading-10 text-center">
                            پرفروشترین محصولات
                        </UiComponentTypography>
                        <div class="flex mt-2 lg:mt-6">
                            <UButton
                                color="sandstone"
                                to="/product/best-sellers"
                                :ui="{ variant: { solid: 'bg-sandstone-700' }, padding: { sm: 'px-12' } }"
                            >
                                مشاهده همه
                            </UButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <UContainer>
            <div class="my-32">
                <PagesIndexBestSelling />
            </div>
        </UContainer>
        <!-- <div class="hidden">
            <div class="my-6 p-8 bg-sandstone-300 dark:bg-sandstone-800 rounded-t-[3rem] md:rounded-t-[5rem] relative">
                <div class="absolute right-0 top-8 md:top-16 h-36 md:h-full">
                    <NuxtImg class="h-full w-full" src="/Images/pages/index/coffee-flower-1.png" />
                </div>
                <div class="pr-16 md:pr-64 flex max-md:flex-col items-center">
                    <div class="w-full md:w-1/3">
                        <UiComponentTypography
                            variant="h5"
                            class-name="text-amazon-700 leading-10 md:pl-16 max-md:text-justify"
                        >
                            شما می‌توانید از طریق فرم ثبت درخواست، درخواست‌های خود را برای ما ارسال کنید. ما در اولین
                            فرصت به تمام درخواست‌ها پاسخ خواهیم داد
                        </UiComponentTypography>
                        <div class="flex gap-4 my-4 md:my-8 justify-end">
                            <div class="w-1/4"></div>
                            <UButton size="md" :ui="{ padding: { md: 'px-16' } }" to="/contact"> ثبت درخواست </UButton>
                        </div>
                    </div>
                    <div class="w-[calc(100%+4rem)] -mr-16 md:w-2/3 py-8 md:px-20">
                        <NuxtImg class="w-full" src="/Images/pages/index/coffee-newsletter-image.png" />
                    </div>
                </div>
            </div>
            <UContainer class="">
                <div class="flex mt-24">
                    <div class="flex flex-col w-1/4 py-8 justify-center pb-16">
                        <UiComponentTypography tag="h4" variant="h2">
                            در
                            <UiBrandText />
                            چه خبر
                        </UiComponentTypography>
                        <div class="mt-6 px-6 flex justify-end">
                            <UButton>
                                {{ $t("more") }}
                            </UButton>
                        </div>
                    </div>
                    <ul class="w-3/4 flex gap-4">
                        <li class="relative flex-1">
                            <NuxtImg src="/Images/pages/index/mockup-1.png" class="w-full" />
                            <div
                                class="absolute bottom-0 right-0 bg-background max-w-[75%] pb-2 px-3 pt-4 rounded-tl-lg"
                            >
                                <UiComponentTypography variant="caption" class-name="text-amazon-600">
                                    قهوه و ارتباط آن با سلامت قلب
                                </UiComponentTypography>
                                <UButton
                                    class="mt-1"
                                    color="gray"
                                    size="xs"
                                    variant="link"
                                    :padded="false"
                                    icon="i-solar-arrow-left-outline"
                                >
                                    {{ $t("more") }}
                                </UButton>
                            </div>
                        </li>
                        <li class="relative flex-1">
                            <NuxtImg src="/Images/pages/index/mockup-2.png" class="w-full" />
                            <div
                                class="absolute bottom-0 right-0 bg-background max-w-[75%] pb-2 px-3 pt-4 rounded-tl-lg"
                            >
                                <UiComponentTypography variant="caption" class-name="text-amazon-600">
                                    قهوه و ارتباط آن با سلامت قلب
                                </UiComponentTypography>
                                <UButton
                                    class="mt-1"
                                    color="gray"
                                    size="xs"
                                    variant="link"
                                    :padded="false"
                                    icon="i-solar-arrow-left-outline"
                                >
                                    {{ $t("more") }}
                                </UButton>
                            </div>
                        </li>
                        <li class="relative flex-1">
                            <NuxtImg src="/Images/pages/index/mockup-1.png" class="w-full" />
                            <div
                                class="absolute bottom-0 right-0 bg-background max-w-[75%] pb-2 px-3 pt-4 rounded-tl-lg"
                            >
                                <UiComponentTypography variant="caption" class-name="text-amazon-600">
                                    قهوه و ارتباط آن با سلامت قلب
                                </UiComponentTypography>
                                <UButton
                                    class="mt-1"
                                    color="gray"
                                    size="xs"
                                    variant="link"
                                    :padded="false"
                                    icon="i-solar-arrow-left-outline"
                                >
                                    {{ $t("more") }}
                                </UButton>
                            </div>
                        </li>
                    </ul>
                </div>
            </UContainer>
        </div> -->
    </div>
</template>

<script lang="ts" setup>
useSeoMeta({
    title: "فروشگاه آنلاین رستری قهوه نرس لند | خرید آنلاین انواع قهوه",
    description:
        "به دنیای قهوه‌های باکیفیت خوش آمدید! قهوه‌های ارگانیک و تخصصی ما را امتحان کنید و لذت واقعی قهوه را با طعم‌های متنوع حس کنید. خرید آسان و ارسال سریع!",
    ogTitle: "فروشگاه آنلاین رستری قهوه نرس لند",
    ogDescription:
        "به دنیای قهوه‌های باکیفیت خوش آمدید! قهوه‌های ارگانیک و تخصصی ما را امتحان کنید و لذت واقعی قهوه را با طعم‌های متنوع حس کنید. خرید آسان و ارسال سریع!",
    ogType: "website",
    ogUrl: "https://northland-co.com",
    canonical: "https://northland-co.com",
    robots: "index, follow",
});

useSchemaOrg([
    defineWebSite({
        name: "Northland Co. | نرس‌لند",
        url: "https://northland-co.com",
        potentialAction: {
            "@type": "SearchAction",
            target: "https://northland-co.com/search?query={search_term_string}",
            "query-input": "required name=search_term_string",
        },
    }),
]);

defineOgImageComponent("Main", {
    title: "فروشگاه آنلاین رستری قهوه نرس لند",
    description:
        "به دنیای قهوه‌های باکیفیت خوش آمدید! قهوه‌های ارگانیک و تخصصی ما را امتحان کنید و لذت واقعی قهوه را با طعم‌های متنوع حس کنید. خرید آسان و ارسال سریع!",
    icon: "i-solar-home-2-line-duotone",
    path: "https://northland-co.com",
});
</script>

<style scoped>
.content-container {
    --offset: 0;
}
@screen md {
    .content-container {
        --offset: 5rem;
    }
}
.remove-extra-shadow::before,
.remove-extra-shadow::after {
    content: "";
    background: #f5f2ec;
    @apply absolute w-10 h-full top-0;
}
.dark .remove-extra-shadow::before,
.dark .remove-extra-shadow::after {
    @apply bg-sandstone-900;
}
.remove-extra-shadow::before {
    @apply -left-5;
}
.remove-extra-shadow::after {
    @apply -right-5;
}
</style>
